import { Scene } from 'phaser';
import { TweenAction } from './TweenAction';

export class RotateAction extends TweenAction {
  protected angle: number;

  constructor(scene: Scene, targets: any, duration: number, angle: number) {
    super(scene, targets, duration);
    this.angle = angle;
  }

  protected setTweenConfig() {
    super.setTweenConfig();
    this.setTweenConfigValue('angle', this.angle);
  }
}